import { Dialog } from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/Help';

import React, { useState, useEffect, useRef } from 'react'
import { Box } from '@mui/system'
const FormHelperDialogWrapper = (props) => {
    const [open, setOpen] = useState(false);


    const toggleHelp = () => {
        setOpen(old => !old);
    };
    const closeHelp = () => {
        setOpen(false);
    };

    const helpIconTheme = {
		//mr: {md:3, xs: 28},
		color: open ? "primary.dark" : "neutral.800", 
		width:"20px",
        mr: 1
	}

    // useEffect(() => {
    //     props.helperWidth ?  :
    // },[props.helperWidth])
    
    return (
        <Box sx={{ position: "relative", display: "flex" }}>    
            {props.children}
            <Box sx={{ position: "absolute", right: -35 }}>
                <HelpIcon  onClick={toggleHelp} sx={helpIconTheme} />
            </Box>
            <Box sx={{ position: "absolute",right:-35, width: props.helperWidth, display: open ? "flex" : "none" }}>
                    <Box sx={{ p: 2, zIndex: 10, position: "absolute", backgroundColor: "primary.main" }}>
                        <CloseIcon onClick={closeHelp} sx={{ position: "absolute", left: 3, top: 3 }} />
                        <Box sx={{mt:1}}>
                            {props.text}
                        </Box>
                </Box>
            </Box>
        </Box>
    )
}

/*Wrapper for help icon so the style is not hardcoded in case we want it multiple times in the app
* It also handles the open and close of the help box ouside the component so it is not in the parent component
*/
export const HelpIconWrapper = ({children, text, sx, info}) => {
    const [open, setOpen] = useState(false);

    const infoIconRef = useRef(null);
    
    const toggleHelp = () => {
        setOpen(old => !old);
    };

    const handleClickOutside = (event) => {
        if(open){
            if (infoIconRef.current && !infoIconRef.current.contains(event.target)) {
                setOpen(false);
            }		
        }
    }
    useEffect(()=> {
        document.addEventListener("mousedown", handleClickOutside)
        return() => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    },[open])

    const helpBoxDimensions = {
		width: sx.helpBoxDimensions.width, 
		position: sx.helpBoxDimensions.position, 
		display: "flex",
		marginLeft: sx.helpBoxDimensions.marginLeft, 
		// marginBottom:sx.helpBoxDimensions.marginBottom,   
		marginTop: sx.helpBoxDimensions.marginTop,   
		display: open ? sx.helpBoxDimensions.display.open : sx.helpBoxDimensions.display.close,
	}

	const helpIconTheme = {
		mr: {md:3, xs: 28},
		color: open ? sx.helpIconTheme.openColors.open : sx.helpIconTheme.openColors.close, 
		width:"18px",
	}


    return(
        <Box>
            <HelpIcon ref={infoIconRef} onClick={toggleHelp} sx={helpIconTheme} />
            <Box sx={helpBoxDimensions}  >
                <Box sx={sx.helpBoxTheme}>
                    {text}
                </Box>
            </Box> 
        </Box>
    )
}

export default FormHelperDialogWrapper
